import ssa_112_1 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_1.pdf";
import ssa_112_2 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_2.pdf";
import ssa_112_3 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_3.pdf";
import ssa_112_4 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_4.pdf";
import ssa_112_5 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_5.pdf";
import ssa_112_6 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_6.pdf";
import ssa_112_7 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_7.pdf";
import ssa_112_8 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_8.pdf";
import ssa_112_9 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_9.pdf";
import ssa_112_10 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_10.pdf";
import ssa_112_11 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_11.pdf";
import ssa_112_12 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_12.pdf";
import ssa_112_13 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_13.pdf";
import ssa_112_14 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_14.pdf";
import ssa_112_15 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_15.pdf";
import ssa_112_16 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_16.pdf";
import ssa_112_17 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_17.pdf";
import ssa_112_18 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_18.pdf";
import ssa_112_19 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_19.pdf";
import ssa_112_20 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_20.pdf";
import ssa_112_21 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_21.pdf";
import ssa_112_22 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_22.pdf";
import ssa_112_23 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_23.pdf";
import ssa_112_24 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_24.pdf";
import ssa_112_25 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_25.pdf";
import ssa_112_26 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_26.pdf";
// import ssa_112_27 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_27.pdf";
// import ssa_112_28 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_28.pdf";
// import ssa_112_29 from "@/assets/studentAwardsRouter/studentAwardsFile/112/ssa_112_29.pdf";
var awardsPath_112 = [
  ssa_112_1,
  ssa_112_2,
  ssa_112_3,
  ssa_112_4,
  ssa_112_5,
  ssa_112_6,
  ssa_112_7,
  ssa_112_8,
  ssa_112_9,
  ssa_112_10,
  ssa_112_11,
  ssa_112_12,
  ssa_112_13,
  ssa_112_14,
  ssa_112_15,
  ssa_112_16,
  ssa_112_17,
  ssa_112_18,
  ssa_112_19,
  ssa_112_20,
  ssa_112_21,
  ssa_112_22,
  ssa_112_23,
  ssa_112_24,
  ssa_112_25,
  ssa_112_26,
//   ssa_112_27,
//   ssa_112_28,
//   ssa_112_29,
];
export { awardsPath_112 };
